<template>
  <div>
    <div>
      <!--      fade-->
      <!--      autoplay-->
      <!--      fixed-height="600px"-->
      <VueperSlides
        fade
        autoplay
        fixed-height="100vh"
        :slide-multiple="false"
        :bullets="true"
        :bullets-outside="false"
        :arrows="true"
        :arrows-outside="false"
        :infinite="true"
        :breakpoints="breakpoints"
      >
        <VueperSlide v-for="item in items" :key="item.id" :image="isMobile ? item.mSrc_m : item.mSrc">
          <template #content>
            <div class="overlay"></div>
            <div class="overlayContent">
              <div class="thirdLine">
                <small>{{ item.intro }}</small>
              </div>
              <div class="firstLine">
                {{ item.title }}
              </div>
              <div class="secondLine">
                <small>{{ item.mDesc }}</small>
              </div>
            </div>
          </template>
        </VueperSlide>
      </VueperSlides>
    </div>
  </div>
</template>

<script>
import {VueperSlides, VueperSlide} from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

export default {
  name: 'MainSlider',
  props: {
    items: Array,
  },
  components: {
    VueperSlides,
    VueperSlide,
  },
  data() {
    return {
      isMobile: window.innerWidth <= 768,
      parallaxFixedContent: true,
      breakpoints: {
        992: {
          bullets: true,
          arrows: false,
          visibleSlides: 1,
          touchable: false,
          disableArrowsOnEdges: true,
          fade: true,
          animation: false,
        },
      },
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style scoped lang="scss">
.overlay {
  color: blue;
  position: absolute;
  z-index: 12;
  left: 0;
  width: 100%;
  text-align: center;
  stroke: red;
  stroke-width: 300;
  background: linear-gradient(rgba(0, 0, 0, 0.3), 20%, rgba(0, 0, 0, 0));
}

.overlayContent {
  color: white;
  position: absolute;
  z-index: 12;
  left: 0;
  top: 42%;
  width: 100%;
  height: 40rem;
  text-align: center;
  stroke-width: 300;
  text-shadow: gray 1px 1px;
  font-family: 'Nanum Gothic', sans-serif;
}

@media (max-width: 768px) {
  .slider-item {
    width: 100%;
    height: 40vh;
  }
  .slider-section {
    margin-top: 64px;
  }

  .firstLine {
    font-size: 25px;
    font-family: 'Nanum Gothic', serif;
  }
  .secondLine {
    font-size: 20px;
    font-family: 'Nanum Gothic', serif;
  }
  .thirdLine {
    font-size: 22px;
    font-family: 'Nanum Gothic', serif;
  }
}

@media (min-width: 768px) {
  .slider-item {
    width: 100%;
    height: 60vh;
  }
  .slider-section {
    margin-top: 0px;
  }

  .firstLine {
    font-size: 35px;
    font-family: 'Nanum Gothic', serif;
  }
  .secondLine {
    font-size: 25px;
    font-family: 'Nanum Gothic', serif;
  }
  .thirdLine {
    font-size: 28px;
    font-family: 'Nanum Gothic', serif;
  }
}

@media (min-width: 1200px) {
  .slider-item {
    width: 100%;
    height: 80vh;
  }
  .slider-section {
    margin-top: 0px;
  }

  .firstLine {
    font-size: 50px;
    font-family: 'Nanum Gothic', serif;
  }
  .secondLine {
    font-size: 35px;
    font-family: 'Nanum Gothic', serif;
    padding: 0;
  }
  .thirdLine {
    font-size: 40px;
    font-family: 'Nanum Gothic', serif;
  }
}

.firstLine {
  font-family: 'Nanum Gothic, serif';
}
.secondLine {
  font-family: 'Nanum Gothic, serif';
}
.thirdLine {
  font-family: 'Nanum Gothic', serif;
}
</style>
